export { default, links, meta } from "./routes/professional_article/main/$articleId.$articleName.tsx";